/**
 * Created by Alex Aguilar on 7/5/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('generateFlightService', generateFlightService);

    generateFlightService.$inject = ['$http', 'CONFIG', 'messageService'];

    function generateFlightService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/generationItineraries',
            service = {
            getGenerateFlights: getGenerateFlights,
            getGenerateFlight: getGenerateFlight,
            saveGenerateFlight: saveGenerateFlight,
            deleteGenerateItinerary: deleteGenerateItinerary
        };

        return service;

        function getGenerateFlights(detailed){
            return $http.get(urlBase +'?detailed=' + detailed)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response){
                return (response.data._embedded) ? response.data._embedded.generatedItineraries : [];
            }
            function getFailed(){
                messageService.findAllError('');
            }
        }

        function getGenerateFlight(generateFlightId){
            return $http.get(urlBase + "/" + generateFlightId )
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('')
                });
        }

        function saveGenerateFlight(generateFlight){
            return $http.post(urlBase, generateFlight)
                .then(saveComplete)
                .catch(getFailed);

            function saveComplete(){
                messageService.register('');
            }
            function getFailed(){
                messageService.registerError('');
            }
        }

        function deleteGenerateItinerary(generateItineraryId){
            return $http.put(urlBase + '/inactivate/' + generateItineraryId)
                .then(saveComplete)
                .catch(getFailed);

            function saveComplete(){
                messageService.itineraryDisabled('');
            }
            function getFailed(){
                messageService.itineraryDisabledError('');
            }
        }
    }
})();

